/* eslint-disable no-empty-pattern */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";

export const addRole = createAsyncThunk(
  "role/addRole",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/addRole", payload);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getRoleById = createAsyncThunk(
  "role/getRoleById",
  async (roleId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/admin/v1/roles/${roleId}?grouped=${true}`
      );
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateRole = createAsyncThunk(
  "role/updateRole",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.put("/api/admin/updateRole", payload);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAllRoles = createAsyncThunk(
  "role/getAllRoles",
  async (excludeInvestor, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/admin/getAllRoles?excludeInvestor=${excludeInvestor}`
      );
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteRole = createAsyncThunk(
  "role/deleteRole",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`/api/admin/v1/roles/${id}`);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAllGroupedPermissions = createAsyncThunk(
  "role/getAllGroupedPermissions",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/admin/v1/permission`);
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const RoleSlice = createSlice({
  name: "role",
  initialState: {
    roleList: [],
    role: {},
    loading: false,
    error: null,
    addRoleLoading: false,
    deleteRoleLoading: false,
    permissionList: [],
  },

  extraReducers: (builder) => {
    builder.addCase(getAllRoles.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getAllRoles.fulfilled, (state, action) => {
      state.loading = false;
      state.roleList = action.payload;
      state.error = null;
    });
    builder.addCase(getAllRoles.rejected, (state, action) => {
      state.loading = false;
      state.roleList = [];
      state.error = action.payload;
    });

    builder.addCase(getAllGroupedPermissions.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getAllGroupedPermissions.fulfilled, (state, action) => {
      state.loading = false;
      state.permissionList = action.payload;
      state.error = null;
    });
    builder.addCase(getAllGroupedPermissions.rejected, (state, action) => {
      state.loading = false;
      state.permissionList = [];
      state.error = action.payload;
    });

    builder.addCase(getRoleById.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getRoleById.fulfilled, (state, action) => {
      state.loading = false;
      state.role = action.payload;
      state.error = null;
    });
    builder.addCase(getRoleById.rejected, (state, action) => {
      state.loading = false;
      state.role = {};
      state.error = action.payload;
    });

    builder.addCase(addRole.pending, (state) => {
      state.error = null;
      state.addRoleLoading = true;
    });
    builder.addCase(addRole.fulfilled, (state, action) => {
      state.error = null;
      state.addRoleLoading = false;
    });
    builder.addCase(addRole.rejected, (state, action) => {
      state.error = action.payload;
      state.addRoleLoading = false;
    });

    builder.addCase(updateRole.pending, (state) => {
      state.addRoleLoading = true;
      state.error = null;
    });
    builder.addCase(updateRole.fulfilled, (state, action) => {
      state.addRoleLoading = false;
      state.error = null;
    });
    builder.addCase(updateRole.rejected, (state, action) => {
      state.addRoleLoading = false;
      state.error = action.payload;
    });

    builder.addCase(deleteRole.pending, (state) => {
      state.deleteRoleLoading = true;
      state.error = null;
    });
    builder.addCase(deleteRole.fulfilled, (state, action) => {
      state.deleteRoleLoading = false;
      state.error = null;
    });
    builder.addCase(deleteRole.rejected, (state, action) => {
      state.deleteRoleLoading = false;
      state.error = action.payload;
    });
  },

  reducers: {},
});

export const {} = RoleSlice.actions;

export default RoleSlice.reducer;
